import React from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { Globe } from "lucide-react";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const change = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    localStorage.setItem("i18n_picked", "1");
    // Best-effort persistence; silently ignore if user is not logged in
    axios.patch("/auth/me/preferences", { preferred_language: lng }, { withCredentials: true }).catch(() => {});
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-1" data-testid="language-switcher-btn">
          <Globe className="w-4 h-4" />
          <span className="uppercase font-semibold text-xs">{i18n.language?.slice(0, 2) || "en"}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => change("en")} data-testid="switch-lang-en">
          🇺🇸 English
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => change("es")} data-testid="switch-lang-es">
          🇪🇸 Español
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
